import styles from "./Avatar.module.scss";

function Avatar() {
  return (
    <img
      className={styles.base}
      src="https://gravatar.com/avatar/f7f98db931dfc1489d86799ca6599ea53c60f89c8730d0c9dda83592c3bf859d.jpeg?s=256"
      alt="exodie"
    />
  );
}

export default Avatar;
